webpackJsonp([1],{

/***/ "1PiW":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('el-row', {
    staticClass: "tac"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": "1",
      "mode": "horizontal",
      "unique-opened": true,
      "theme": "dark"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.displayName === -1 ? '未登录' : _vm.displayName))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_vm._v("\n            修改密码\n          ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2"
    }
  }, [_vm._v("\n            退出\n          ")])], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "23S4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Sidebar__ = __webpack_require__("wXMN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Top__ = __webpack_require__("6eyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Top___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Top__);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      title: ''
    };
  },

  components: {
    sidebar: __WEBPACK_IMPORTED_MODULE_0__pages_Sidebar___default.a,
    top: __WEBPACK_IMPORTED_MODULE_1__pages_Top___default.a
  }
});

/***/ }),

/***/ "3ROs":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),

/***/ "3S7T":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "right",
      "model": _vm.form,
      "label-width": "40px"
    }
  }, [_c('p', {
    staticClass: "align-center",
    attrs: {
      "label-width": "0"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "on"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "on"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("登陆")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "3jL2":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("BEim")
}
var Component = __webpack_require__("AVtK")(
  /* script */
  __webpack_require__("o70f"),
  /* template */
  __webpack_require__("3S7T"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ac05a2c4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "3rbi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5/fi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("aA9S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var blackModelArr = ['option', 'user'];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'create',
  props: ['options'],
  data: function data() {
    var isPost = this.options.name === 'post';
    var isPage = this.options.name === 'page';
    var form = this.options.items.reduce(function (prev, curr) {
      prev[curr.prop] = curr.default;
      return prev;
    }, {});
    return {
      isPost: isPost,
      isPage: isPage,
      form: form,
      isLoading: true
    };
  },

  computed: {
    list: function list() {
      return this.$store.state.list;
    }
  },
  methods: {
    parseTypeBeforeSubmit: function parseTypeBeforeSubmit() {
      var _this = this;

      var isOk = true;
      this.options.items.forEach(function (item) {
        try {
          if (item.sourceType === 'Object') {
            _this.form[item.prop] = JSON.parse(_this.form[item.prop], null, 2);
          }
        } catch (err) {
          isOk = false;
        }
      });
      return isOk;
    },
    parseTypeAfterFetch: function parseTypeAfterFetch() {
      var _this2 = this;

      this.options.items.forEach(function (item) {
        if (item.sourceType === 'Object') {
          _this2.form[item.prop] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this2.form[item.prop], null, 2);
        }
      });
    },
    setParams: function setParams(response) {
      var id = this.$route.params.id;
      if (response._id && typeof id === 'undefined') {
        this.$router.replace({ params: { id: response._id } });
        this.form = response;
      }
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      if (this.parseTypeBeforeSubmit() === false) {
        return this.$message.error('属性验证失败');
      }
      var id = this.$route.params.id;
      if (typeof id !== 'undefined') {
        // patch
        return this.$store.dispatch('PATCH', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
          id: this.$route.params.id,
          form: this.form
        }, this.options)).then(function (response) {
          _this3.parseTypeAfterFetch();
          _this3.$message({
            message: '已成功提交',
            type: 'success'
          });
          _this3.setParams(response);
        }).catch(function (err) {
          return console.error(err);
        });
      } else {
        // post
        return this.$store.dispatch('POST', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
          form: this.form
        }, this.options)).then(function (response) {
          _this3.parseTypeAfterFetch();
          _this3.$message({
            message: '已成功提交',
            type: 'success'
          });
          var model = _this3.options.model;
          if (blackModelArr.indexOf(model) === -1) {
            _this3.setParams(response);
          }
        }).catch(function (err) {
          return console.error(err);
        });
      }
    }
  },
  created: function created() {
    var _this4 = this;

    // flatten user and options into obj
    if (this.options.isPlain === true) {
      return this.$store.dispatch('FETCH_CREATE', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        id: -1
      }, this.options)).then(function () {
        _this4.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.$store.state.curr);
        _this4.isLoading = false;
      });
    }

    // if  params has value,fetch from the model
    if (typeof this.$route.params.id !== 'undefined') {
      return this.$store.dispatch('FETCH_CREATE', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        id: this.$route.params.id
      }, this.options)).then(function () {
        _this4.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.$store.state.curr);
        _this4.isLoading = false;
      });
    } else {}
  }
});

/***/ }),

/***/ "5A03":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_api__ = __webpack_require__("vZNG");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'logout',
  methods: {
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__store_api__["a" /* default */].logout().then(function (response) {
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        _this.$message({
          title: '成功',
          message: '登出成功',
          type: 'success',
          duration: 2000
        });
        _this.$router.push({ path: '/admin/login' });
      }).catch(function () {});
    }
  },
  watch: {
    '$route': function $route(route) {
      if (route.name === 'logout') {
        this.logout();
      }
    }
  },
  created: function created() {
    this.logout();
  }
});

/***/ }),

/***/ "6eyd":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("AHfA")
}
var Component = __webpack_require__("AVtK")(
  /* script */
  __webpack_require__("yxhs"),
  /* template */
  __webpack_require__("1PiW"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1ad7cdca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "7fRy":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "U5mi",
	"./af.js": "U5mi",
	"./ar": "70tt",
	"./ar-dz": "V5d1",
	"./ar-dz.js": "V5d1",
	"./ar-kw": "8Kf6",
	"./ar-kw.js": "8Kf6",
	"./ar-ly": "5lAg",
	"./ar-ly.js": "5lAg",
	"./ar-ma": "6hZg",
	"./ar-ma.js": "6hZg",
	"./ar-sa": "jQS8",
	"./ar-sa.js": "jQS8",
	"./ar-tn": "L7Sn",
	"./ar-tn.js": "L7Sn",
	"./ar.js": "70tt",
	"./az": "bt++",
	"./az.js": "bt++",
	"./be": "wQYm",
	"./be.js": "wQYm",
	"./bg": "CCLY",
	"./bg.js": "CCLY",
	"./bm": "aTdr",
	"./bm.js": "aTdr",
	"./bn": "K2H7",
	"./bn.js": "K2H7",
	"./bo": "MYDx",
	"./bo.js": "MYDx",
	"./br": "E5oa",
	"./br.js": "E5oa",
	"./bs": "ShN7",
	"./bs.js": "ShN7",
	"./ca": "/jA6",
	"./ca.js": "/jA6",
	"./cs": "pmLo",
	"./cs.js": "pmLo",
	"./cv": "zEco",
	"./cv.js": "zEco",
	"./cy": "FEim",
	"./cy.js": "FEim",
	"./da": "vjy2",
	"./da.js": "vjy2",
	"./de": "Uc6c",
	"./de-at": "dDya",
	"./de-at.js": "dDya",
	"./de-ch": "hRzC",
	"./de-ch.js": "hRzC",
	"./de.js": "Uc6c",
	"./dv": "1+G4",
	"./dv.js": "1+G4",
	"./el": "kMBi",
	"./el.js": "kMBi",
	"./en-au": "i97b",
	"./en-au.js": "i97b",
	"./en-ca": "1Kkq",
	"./en-ca.js": "1Kkq",
	"./en-gb": "JWnI",
	"./en-gb.js": "JWnI",
	"./en-ie": "LjSC",
	"./en-ie.js": "LjSC",
	"./en-nz": "V2a0",
	"./en-nz.js": "V2a0",
	"./eo": "a0I0",
	"./eo.js": "a0I0",
	"./es": "USRr",
	"./es-do": "tOul",
	"./es-do.js": "tOul",
	"./es-us": "N8IG",
	"./es-us.js": "N8IG",
	"./es.js": "USRr",
	"./et": "Jl3j",
	"./et.js": "Jl3j",
	"./eu": "QRPT",
	"./eu.js": "QRPT",
	"./fa": "q4/k",
	"./fa.js": "q4/k",
	"./fi": "olX5",
	"./fi.js": "olX5",
	"./fo": "MCy+",
	"./fo.js": "MCy+",
	"./fr": "M4ob",
	"./fr-ca": "WUOG",
	"./fr-ca.js": "WUOG",
	"./fr-ch": "+LbW",
	"./fr-ch.js": "+LbW",
	"./fr.js": "M4ob",
	"./fy": "REnV",
	"./fy.js": "REnV",
	"./gd": "2wEn",
	"./gd.js": "2wEn",
	"./gl": "To3L",
	"./gl.js": "To3L",
	"./gom-latn": "q2fo",
	"./gom-latn.js": "q2fo",
	"./gu": "o92n",
	"./gu.js": "o92n",
	"./he": "UfqB",
	"./he.js": "UfqB",
	"./hi": "RZzY",
	"./hi.js": "RZzY",
	"./hr": "Cd0N",
	"./hr.js": "Cd0N",
	"./hu": "JMlg",
	"./hu.js": "JMlg",
	"./hy-am": "8CDn",
	"./hy-am.js": "8CDn",
	"./id": "Ct2s",
	"./id.js": "Ct2s",
	"./is": "t26K",
	"./is.js": "t26K",
	"./it": "haPy",
	"./it.js": "haPy",
	"./ja": "VKuq",
	"./ja.js": "VKuq",
	"./jv": "6zM0",
	"./jv.js": "6zM0",
	"./ka": "RBGw",
	"./ka.js": "RBGw",
	"./kk": "HNoQ",
	"./kk.js": "HNoQ",
	"./km": "bMcz",
	"./km.js": "bMcz",
	"./kn": "cXkW",
	"./kn.js": "cXkW",
	"./ko": "BtUI",
	"./ko.js": "BtUI",
	"./ky": "N5d9",
	"./ky.js": "N5d9",
	"./lb": "fI6P",
	"./lb.js": "fI6P",
	"./lo": "UwiY",
	"./lo.js": "UwiY",
	"./lt": "/LqS",
	"./lt.js": "/LqS",
	"./lv": "Z61T",
	"./lv.js": "Z61T",
	"./me": "QvLz",
	"./me.js": "QvLz",
	"./mi": "u+XU",
	"./mi.js": "u+XU",
	"./mk": "NfVd",
	"./mk.js": "NfVd",
	"./ml": "zUFV",
	"./ml.js": "zUFV",
	"./mr": "d0bU",
	"./mr.js": "d0bU",
	"./ms": "VMLn",
	"./ms-my": "s8vs",
	"./ms-my.js": "s8vs",
	"./ms.js": "VMLn",
	"./mt": "UQe0",
	"./mt.js": "UQe0",
	"./my": "2XfN",
	"./my.js": "2XfN",
	"./nb": "Mmzd",
	"./nb.js": "Mmzd",
	"./ne": "624x",
	"./ne.js": "624x",
	"./nl": "DLoo",
	"./nl-be": "JRFb",
	"./nl-be.js": "JRFb",
	"./nl.js": "DLoo",
	"./nn": "rSKj",
	"./nn.js": "rSKj",
	"./pa-in": "a9aR",
	"./pa-in.js": "a9aR",
	"./pl": "Jv93",
	"./pl.js": "Jv93",
	"./pt": "8cQn",
	"./pt-br": "a6Me",
	"./pt-br.js": "a6Me",
	"./pt.js": "8cQn",
	"./ro": "+QLR",
	"./ro.js": "+QLR",
	"./ru": "Dx5j",
	"./ru.js": "Dx5j",
	"./sd": "EESZ",
	"./sd.js": "EESZ",
	"./se": "GIHS",
	"./se.js": "GIHS",
	"./si": "Natn",
	"./si.js": "Natn",
	"./sk": "AvTU",
	"./sk.js": "AvTU",
	"./sl": "x0Xd",
	"./sl.js": "x0Xd",
	"./sq": "sNAV",
	"./sq.js": "sNAV",
	"./sr": "OvpH",
	"./sr-cyrl": "fUV8",
	"./sr-cyrl.js": "fUV8",
	"./sr.js": "OvpH",
	"./ss": "dhCU",
	"./ss.js": "dhCU",
	"./sv": "eOzh",
	"./sv.js": "eOzh",
	"./sw": "oMRk",
	"./sw.js": "oMRk",
	"./ta": "jlhQ",
	"./ta.js": "jlhQ",
	"./te": "AjG4",
	"./te.js": "AjG4",
	"./tet": "jAbp",
	"./tet.js": "jAbp",
	"./th": "F3gE",
	"./th.js": "F3gE",
	"./tl-ph": "lxTH",
	"./tl-ph.js": "lxTH",
	"./tlh": "ojB5",
	"./tlh.js": "ojB5",
	"./tr": "F5Uk",
	"./tr.js": "F5Uk",
	"./tzl": "T93j",
	"./tzl.js": "T93j",
	"./tzm": "pnBN",
	"./tzm-latn": "YjoS",
	"./tzm-latn.js": "YjoS",
	"./tzm.js": "pnBN",
	"./uk": "FLQK",
	"./uk.js": "FLQK",
	"./ur": "JXCW",
	"./ur.js": "JXCW",
	"./uz": "KHZz",
	"./uz-latn": "nZwI",
	"./uz-latn.js": "nZwI",
	"./uz.js": "KHZz",
	"./vi": "Qu/i",
	"./vi.js": "Qu/i",
	"./x-pseudo": "OjVM",
	"./x-pseudo.js": "OjVM",
	"./yo": "DOwN",
	"./yo.js": "DOwN",
	"./zh-cn": "gvOa",
	"./zh-cn.js": "gvOa",
	"./zh-hk": "ijSq",
	"./zh-hk.js": "ijSq",
	"./zh-tw": "RFvw",
	"./zh-tw.js": "RFvw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7fRy";

/***/ }),

/***/ "AHfA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ATuT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return marked; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked__ = __webpack_require__("xErG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highlight_js__ = __webpack_require__("eh2P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highlight_js__);
/**
 * Created by unsad on 2017/10/18.
 */



var renderer = new __WEBPACK_IMPORTED_MODULE_0_marked___default.a.Renderer();
var toc = [];

renderer.heading = function (text, level) {
  var slug = text.toLowerCase().replace(/[:~/+\s]/g, '-');
  toc.push({
    level: level,
    slug: slug,
    title: text
  });
  return '<h' + level + '><a href=\'#' + slug + '\' id=\'' + slug + '\' class=\'anchor\'></a><a href=\'#' + slug + '\'>' + text + '</a></h' + level + '>';
};

__WEBPACK_IMPORTED_MODULE_0_marked___default.a.setOptions({
  highlight: function highlight(code, lang) {
    if (__WEBPACK_IMPORTED_MODULE_1_highlight_js___default.a.getLanguage(lang)) {
      return __WEBPACK_IMPORTED_MODULE_1_highlight_js___default.a.highlight(lang, code).value;
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_highlight_js___default.a.highlightAuto(code).value;
    }
  },
  renderer: renderer
});

var marked = function marked(text) {
  var tok = __WEBPACK_IMPORTED_MODULE_0_marked___default.a.lexer(text);
  text = __WEBPACK_IMPORTED_MODULE_0_marked___default.a.parser(tok).replace(/<pre>/ig, '<pre class="hljs">');
  return text;
};

/***/ }),

/***/ "BEim":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BMiz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dep7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dp+O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_Post_vue__ = __webpack_require__("XmUI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_Post_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__containers_Post_vue__);
/**
 * Created by unsad on 2017/10/15.
 */


/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  return {
    name: options.name + '-markdown-view',
    asyncData: function asyncData(_ref) {
      var store = _ref.store;

      return store.dispatch('FETCH_LIST', options);
    },
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_0__containers_Post_vue___default.a, { props: { options: options } });
    }
  };
});

/***/ }),

/***/ "F5Qf":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("ZLEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("VCXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("9rMa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("vZNG");


/**
 * Created by unsad on 2017/10/14.
 */




__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    siteInfo: {},
    list: [],
    curr: {},
    user: {}
  },
  actions: {
    GET_IMAGE_HEIGHT: function GET_IMAGE_HEIGHT(_ref, _ref2) {
      var commit = _ref.commit,
          state = _ref.state;
      var url = _ref2.url;

      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getImageHeight(url).then(function (data) {
        return data.height || 100;
      });
    },
    FETCH: function FETCH(_ref3, _ref4) {
      var commit = _ref3.commit,
          state = _ref3.state;
      var model = _ref4.model,
          query = _ref4.query;

      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].fetchList(model, query);
    },
    FETCH_BY_ID: function FETCH_BY_ID(_ref5, _ref6) {
      var commit = _ref5.commit,
          state = _ref5.state;
      var model = _ref6.model,
          id = _ref6.id,
          query = _ref6.query;

      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].fetchByID(model, id, query);
    },
    FETCH_LIST: function FETCH_LIST(_ref7, _ref8) {
      var commit = _ref7.commit,
          state = _ref7.state;
      var model = _ref8.model,
          query = _ref8.query;

      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].fetchList(model, query).then(function (obj) {
        commit('SET_LIST', { obj: obj });
      });
    },
    FETCH_CREATE: function FETCH_CREATE(_ref9, _ref10) {
      var commit = _ref9.commit,
          state = _ref9.state;
      var model = _ref10.model,
          id = _ref10.id,
          query = _ref10.query;

      if (id === -1) {
        return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].fetchList(model, query).then(function (curr) {
          var obj = curr.reduce(function (prev, value) {
            if (model === 'option') {
              prev[value.key] = value.value;
            } else if (model === 'user') {
              __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(value).forEach(function (item) {
                prev[item] = value[item];
              });
            }
            return prev;
          }, {});
          commit('SET_CURR', { obj: obj });
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].fetchByID(model, id, query).then(function (obj) {
          console.log('fetch id', obj);
          commit('SET_CURR', { obj: obj });
        });
      }
    },

    POST: function POST(_ref11, _ref12) {
      var commit = _ref11.commit,
          state = _ref11.state;
      var model = _ref12.model,
          form = _ref12.form;

      if (model !== 'post' && model !== 'option' && model !== 'user') {
        return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].post(model, form);
      } else if (model === 'user' || model === 'post') {
        var id = form._id;

        if (typeof id !== 'undefined') {
          return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].patchByID(model, id, form).then(function (result) {
            if (model === 'user') {
              commit('SET_USER', { user: result });
            }
            return result;
          });
        } else {
          return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].post(model, form);
        }
      } else if (model === 'option') {
        var promiseArr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(form).reduce(function (prev, curr) {
          if (form[curr] !== state.curr[curr]) {
            var _id = state.siteInfo[curr]._id;

            var promise = __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].patchByID(model, _id, {
              value: form[curr]
            });
            prev.push(promise);
          }
          return prev;
        }, []);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promiseArr);
      }
    },
    GET_IMAGE_TOKEN: function GET_IMAGE_TOKEN(_ref13, body) {
      var commit = _ref13.commit,
          state = _ref13.state;

      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getImageToken(body);
    },
    PATCH: function PATCH(_ref14, _ref15) {
      var commit = _ref14.commit,
          state = _ref14.state;
      var model = _ref15.model,
          id = _ref15.id,
          form = _ref15.form;

      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].patchByID(model, id, form);
    },
    FETCH_USER: function FETCH_USER(_ref16, _ref17) {
      var commit = _ref16.commit,
          state = _ref16.state;
      var model = _ref17.model,
          query = _ref17.query,
          username = _ref17.username;

      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].fetchList(model, query).then(function (result) {
        for (var i = 0, len = result.length; i < len; i++) {
          var user = result[i];
          if (user.name === username) {
            commit('SET_USER', { user: user });
            break;
          }
        }
      });
    },
    DELETE: function DELETE(_ref18, _ref19) {
      var commit = _ref18.commit,
          state = _ref18.state;
      var model = _ref19.model,
          id = _ref19.id;

      console.log(model, id);
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].deleteByID(model, id);
    },
    FETCH_OPTIONS: function FETCH_OPTIONS(_ref20) {
      var commit = _ref20.commit,
          state = _ref20.state;

      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].fetchList('option', {}).then(function (optionArr) {
        var obj = optionArr.reduce(function (prev, curr) {
          prev[curr.key] = curr;
          return prev;
        }, {});
        commit('SET_OPTIONS', { obj: obj });
      });
    }
  },

  mutations: {
    SET_LIST: function SET_LIST(state, _ref21) {
      var obj = _ref21.obj;

      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'list', obj);
    },
    SET_OPTIONS: function SET_OPTIONS(state, _ref22) {
      var obj = _ref22.obj;

      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'siteInfo', obj);
    },
    SET_CURR: function SET_CURR(state, _ref23) {
      var obj = _ref23.obj;

      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'curr', obj);
    },
    SET_USER: function SET_USER(state, _ref24) {
      var user = _ref24.user;

      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'user', user);
    }
  },
  getters: {}
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "Ja2Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("jtY0")
}
var Component = __webpack_require__("AVtK")(
  /* script */
  __webpack_require__("d7n3"),
  /* template */
  __webpack_require__("F5Qf"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("VCXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__("R7qP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__ = __webpack_require__("Dep7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__("+944");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ "P1lX":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("wYys")
}
var Component = __webpack_require__("AVtK")(
  /* script */
  __webpack_require__("5A03"),
  /* template */
  __webpack_require__("3ROs"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a8ca4b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "QPbI":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("oIJa")
}
var Component = __webpack_require__("AVtK")(
  /* script */
  __webpack_require__("gRTk"),
  /* template */
  __webpack_require__("zvdn"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ce6c0cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "VSkY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_List_vue__ = __webpack_require__("snFu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__containers_List_vue__);


/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  return {
    name: options.name + '-list-view',
    asyncData: function asyncData(_ref) {
      var store = _ref.store;

      return store.dispatch('FETCH_LIST', options);
    },
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_0__containers_List_vue___default.a, { props: { options: options } });
    }
  };
});

/***/ }),

/***/ "XG0p":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('top'), _vm._v(" "), _c('sidebar'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('router-view', {
    key: _vm.$route.params.id || -1
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "XRZy":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("BMiz")
}
var Component = __webpack_require__("AVtK")(
  /* script */
  __webpack_require__("oaya"),
  /* template */
  __webpack_require__("Z+lF"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c06c5c9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "XmUI":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("fEx8")
}
var Component = __webpack_require__("AVtK")(
  /* script */
  __webpack_require__("szkk"),
  /* template */
  __webpack_require__("aDLC"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-95a57306",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "XnCc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("VCXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("cigS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_CreateListView__ = __webpack_require__("VSkY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_CreateEditView__ = __webpack_require__("Z2f2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_CreateMarkdownView__ = __webpack_require__("Dp+O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Login__ = __webpack_require__("3jL2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Logout__ = __webpack_require__("P1lX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_Logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_Dashboard__ = __webpack_require__("XRZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pages_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Main__ = __webpack_require__("s6+2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Main__);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
  routes: [{
    path: '/admin/login',
    name: 'login',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_5__components_pages_Login___default.a
    }
  }, {
    path: '/admin/logout',
    name: 'logout',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_6__components_pages_Logout___default.a
    }
  }, {
    path: '/dashboard',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Main___default.a,
    children: [{
      path: '/',
      name: 'dashboard',
      component: __WEBPACK_IMPORTED_MODULE_7__components_pages_Dashboard___default.a
    }]
  }, {
    path: '/post',
    name: 'post',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Main___default.a,
    children: [{
      path: 'list',
      name: 'postList',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_views_CreateListView__["a" /* default */])({
        name: 'post',
        model: 'post',
        isButtonFixed: true,
        items: [{
          prop: 'title',
          label: '标题',
          width: 300
        }, {
          prop: 'pathName',
          label: '路径',
          width: 300
        }],
        query: {
          conditions: {
            type: 'post'
          },
          select: {
            title: 1,
            pathName: 1,
            tags: 1,
            category: 1
          },
          sort: {
            createdAt: -1
          }
        }
      })
    }, {
      path: 'create/:id?',
      name: 'postCreate',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__components_views_CreateMarkdownView__["a" /* default */])({
        name: 'post',
        model: 'post',
        items: [{
          prop: 'title',
          label: '标题',
          type: 'input',
          default: '',
          width: 250
        }, {
          prop: 'pathName',
          label: '路径',
          type: 'input',
          default: '',
          width: 250,
          description: '唯一标志在前端路径显示'
        }, {
          prop: 'markdownContent',
          label: '内容',
          type: 'markdown',
          default: '',
          width: 170,
          subProp: 'markdownToc'
        }, {
          type: 'split'
        }, {
          prop: 'createdAt',
          label: '创建日期',
          type: 'date-picker',
          default: '',
          width: 170
        }, {
          prop: 'updatedAt',
          label: '修改日期',
          type: 'date-picker',
          default: '',
          width: 170
        }, {
          prop: 'tags',
          label: '标签',
          type: 'select',
          default: [],
          width: 170
        }, {
          prop: 'category',
          label: '分类',
          type: 'radio',
          default: '',
          width: 170
        }, {
          prop: 'isPublic',
          label: '是否公开',
          type: 'switch',
          default: true,
          width: 170
        }, {
          prop: 'allowComment',
          label: '允许评论',
          type: 'switch',
          default: true,
          width: 170
        }],
        query: {
          conditions: {
            type: 'post'
          },
          select: {
            title: 1,
            pathName: 1,
            tags: 1,
            category: 1,
            isPublic: 1,
            allowComment: 1,
            updatedAt: 1,
            createdAt: 1,
            markdownContent: 1,
            type: 1,
            markdownToc: 1
          }
        }
      })
    }]
  }, {
    path: '/page',
    name: 'page',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Main___default.a,
    children: [{
      path: 'list',
      name: 'pageList',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_views_CreateListView__["a" /* default */])({
        name: 'page',
        model: 'post',
        items: [{
          prop: 'pathName',
          label: '路径',
          width: 170
        }, {
          prop: 'createdAt',
          label: '创建日期',
          width: 170
        }, {
          prop: 'updatedAt',
          label: '修改日期',
          width: 170
        }],
        query: {
          conditions: {
            type: 'page'
          },
          select: {
            title: 1,
            pathName: 1,
            createdAt: 1,
            updatedAt: 1
          },
          sort: {
            createdAt: -1
          }
        }
      })
    }, {
      path: 'create/:id?',
      name: 'pageCreate',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__components_views_CreateMarkdownView__["a" /* default */])({
        name: 'page',
        model: 'post',
        items: [{
          prop: 'title',
          label: '标题',
          type: 'input',
          default: '',
          width: 250
        }, {
          prop: 'pathName',
          label: '路径',
          type: 'input',
          default: '',
          width: 250,
          description: '前端路径标志'
        }, {
          prop: 'markdownContent',
          label: '内容',
          type: 'markdown',
          default: '',
          width: 170,
          subProp: 'markdownToc'
        }, {
          type: 'split'
        }, {
          prop: 'createdAt',
          label: '创建日期',
          type: 'date-picker',
          default: '',
          width: 170
        }, {
          prop: 'updatedAt',
          label: '修改日期',
          type: 'date-picker',
          default: '',
          width: 170
        }, {
          prop: 'isPublic',
          label: '是否公开',
          type: 'switch',
          default: true,
          width: 170
        }, {
          prop: 'allowComment',
          label: '允许评论',
          type: 'switch',
          default: true,
          width: 170
        }],
        query: {
          conditions: {
            type: 'page'
          },
          select: {
            title: 1,
            pathName: 1,
            isPublic: 1,
            allowComment: 1,
            updatedAt: 1,
            createdAt: 1,
            markdownContent: 1,
            type: 1,
            markdownToc: 1
          }
        }
      })
    }]
  }, {
    path: '/theme',
    name: 'theme',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Main___default.a,
    children: [{
      path: 'list',
      name: 'themeList',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_views_CreateListView__["a" /* default */])({
        name: 'theme',
        model: 'theme',
        items: [{
          prop: 'name',
          label: '主题',
          width: 250
        }, {
          prop: 'author',
          label: '作者'
        }],
        query: {}
      })
    }, {
      path: 'create/:id',
      name: 'themeEdit',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_views_CreateEditView__["a" /* default */])({
        name: 'theme',
        model: 'theme',
        items: [{
          prop: 'name',
          label: '主题名称',
          width: 250
        }, {
          prop: 'author',
          label: '作者',
          width: 170
        }, {
          prop: 'option',
          label: '配置',
          width: 170,
          type: 'textarea',
          sourceType: 'Object',
          description: '配置内容应为一个JSON对象，不符合JSON格式时提交将被忽略'
        }],
        query: {}
      })
    }]
  }, {
    path: '/cate',
    name: 'cate',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Main___default.a,
    children: [{
      path: 'list',
      name: 'cateList',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_views_CreateListView__["a" /* default */])({
        name: 'cate',
        model: 'category',
        items: [{
          prop: 'name',
          label: '分类',
          width: 250
        }],
        query: {}
      })
    }, {
      path: 'create/:id?',
      name: 'cateCreate',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_views_CreateEditView__["a" /* default */])({
        name: 'cate',
        model: 'category',
        items: [{
          prop: 'name',
          label: '分类名称',
          width: 250
        }],
        query: {}
      })
    }]
  }, {
    path: '/tag',
    name: 'tag',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Main___default.a,
    children: [{
      path: 'list',
      name: 'tagList',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_views_CreateListView__["a" /* default */])({
        name: 'tag',
        model: 'tag',
        items: [{
          prop: 'name',
          label: '标签',
          width: 250
        }],
        query: {}
      })
    }, {
      path: 'create/:id?',
      name: 'tagCreate',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_views_CreateEditView__["a" /* default */])({
        name: 'tag',
        model: 'tag',
        items: [{
          prop: 'name',
          label: '标签名称',
          width: 250
        }],
        query: {}
      })
    }]
  }, {
    path: '/music',
    name: 'music',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Main___default.a,
    children: [{
      path: 'list',
      name: 'musicList',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_views_CreateListView__["a" /* default */])({
        name: 'music',
        model: 'music',
        items: [{
          prop: 'title',
          label: '音乐名称',
          width: 250
        }],
        query: {}
      })
    }, {
      path: 'create/:id?',
      name: 'musicCreate',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_views_CreateEditView__["a" /* default */])({
        name: 'music',
        model: 'music',
        items: [{
          prop: 'title',
          label: '音乐名称',
          width: 250
        }, {
          prop: 'author',
          label: '歌手',
          width: 250
        }, {
          prop: 'url',
          label: '外链地址',
          width: 250
        }, {
          prop: 'lyric',
          label: '歌词地址',
          width: 250
        }],
        query: {}
      })
    }]
  }, {
    path: '/user',
    name: 'user',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Main___default.a,
    children: [{
      path: 'edit',
      name: 'userEdit',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_views_CreateEditView__["a" /* default */])({
        name: 'user',
        model: 'user',
        isPlain: true,
        items: [{
          prop: 'name',
          label: '账号',
          default: '',
          width: 250
        }, {
          prop: 'password',
          label: '密码',
          default: '',
          width: 170
        }, {
          prop: 'displayName',
          label: '昵称',
          default: '',
          width: 170,
          description: '后台管理顶部导航栏显示'
        }, {
          prop: 'email',
          label: '邮箱',
          default: '',
          width: 170,
          description: '文章被回复时需要通知的邮箱，可为空'
        }, {
          prop: 'imageToken',
          label: '七牛Token',
          default: '',
          width: 170
        }],
        query: {}
      })
    }]
  }, {
    path: '/option',
    name: 'option',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Main___default.a,
    children: [{
      path: 'general',
      name: 'optionGeneral',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_views_CreateEditView__["a" /* default */])({
        name: 'general',
        model: 'option',
        isPlain: true,
        items: [{
          prop: 'title',
          label: '网站名称',
          default: '',
          width: 250,
          description: '前后台标题'
        }, {
          prop: 'logoUrl',
          label: 'logo地址',
          default: '',
          width: 170,
          description: '前后台图标，80 X 80'
        }, {
          prop: 'description',
          label: '站点描述',
          default: '',
          width: 170,
          description: '前后台侧边栏描述'
        }, {
          prop: 'siteUrl',
          label: '网站地址',
          default: '',
          width: 170,
          description: '前台域名'
        }, {
          prop: 'faviconUrl',
          label: 'favicon地址',
          default: '',
          width: 170,
          description: '前台favicon地址，相对前台的根路径'
        }, {
          prop: 'keywords',
          label: '关键词',
          default: '',
          width: 170,
          description: 'meta的keywords便于seo'
        }, {
          prop: 'githubUrl',
          label: 'github地址',
          default: '',
          width: 170,
          description: 'github用户名'
        }, {
          prop: 'weiboUrl',
          label: '微博地址',
          default: '',
          width: 170,
          description: '微博地址全部链接'
        }, {
          prop: 'miitbeian',
          label: '网站备案号',
          default: '',
          width: 170,
          description: '前台底部显示'
        }],
        query: {}
      })
    }, {
      path: 'comment',
      name: 'optionComment',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_views_CreateEditView__["a" /* default */])({
        name: 'comment',
        model: 'option',
        isPlain: true,
        items: [{
          prop: 'commentType',
          label: '评论类型',
          default: '',
          width: 250,
          description: '仅支持disqus'
        }, {
          prop: 'commentName',
          label: '评论名称',
          default: '',
          width: 250,
          description: 'disqus的id'
        }],
        query: {}
      })

    }, {
      path: 'analytic',
      name: 'optionAnalytic',
      component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_views_CreateEditView__["a" /* default */])({
        name: 'analytic',
        model: 'option',
        isPlain: true,
        items: [{
          prop: 'analyzeCode',
          label: '统计代码',
          default: '',
          width: 250,
          description: '谷歌统计的id'
        }],
        query: {}
      })
    }]
  }, {
    path: '/',
    redirect: '/admin/login'
  }]
}));

/***/ }),

/***/ "Z+lF":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h1', [_vm._v("网站概要")]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'postCreate'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("撰写新文章")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'optionGeneral'
      }
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "info"
    }
  }, [_vm._v("系统设置")])], 1)], 1)]), _vm._v(" "), _c('el-slider', {
    staticStyle: {
      "margin-top": "20px"
    },
    model: {
      value: (_vm.sliderValue),
      callback: function($$v) {
        _vm.sliderValue = $$v
      },
      expression: "sliderValue"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "recent"
  }, [_c('el-tree', {
    staticStyle: {
      "border-width": "0px"
    },
    attrs: {
      "default-expand-all": true,
      "data": _vm.data,
      "props": _vm.defaultProps
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "Z2f2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_Create_vue__ = __webpack_require__("aR/N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_Create_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__containers_Create_vue__);
/**
 * Created by unsad on 2017/10/14.
 */


/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  return {
    name: options.name + '-create-view',
    asyncData: function asyncData(_ref) {
      var store = _ref.store;

      return store.dispatch('FETCH_LIST', options);
    },
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_0__containers_Create_vue___default.a, { props: { options: options } });
    }
  };
});

/***/ }),

/***/ "aDLC":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.isLoading),
      expression: "isLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "form",
    staticClass: "post-form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, _vm._l((_vm.prevItems), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": item.label
      }
    }, [(item.type === 'input') ? _c('el-input', {
      attrs: {
        "placeholder": item.description || ''
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'markdown') ? _c('markdown', {
      attrs: {
        "toc": _vm.form[item.subProp]
      },
      on: {
        "change": function($event) {
          _vm.form[item.subProp] = arguments[0]
        }
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'radio') ? _c('el-radio', {
      attrs: {
        "label": item.label
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }) : _vm._e()], 1)
  })), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "20px"
    }
  }, [_c('el-button', {
    class: {
      'margin-left': true
    },
    attrs: {
      "type": "info"
    },
    nativeOn: {
      "click": function($event) {
        _vm.jump('prev')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-d-arrow-left"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info"
    },
    nativeOn: {
      "click": function($event) {
        _vm.jump('next')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-d-arrow-right"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "20px"
    }
  }, [_c('el-button', {
    class: {
      'margin-left': true
    },
    attrs: {
      "type": "info"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSaveToc($event)
      }
    }
  }, [_vm._v("生成目录")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("提交文章")])], 1), _vm._v(" "), _vm._l((_vm.nextItems), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": item.label
      }
    }, [(item.type === 'markdown') ? _c('markdown', {
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'date-picker') ? _c('el-date-picker', {
      attrs: {
        "type": "datetime",
        "placeholder": "选择日期时间"
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'select') ? _c('el-select', {
      attrs: {
        "multiple": ""
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }, _vm._l((_vm.tags), function(tag, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": tag,
          "value": tag
        }
      })
    })) : _vm._e(), _vm._v(" "), (item.type === 'radio') ? _c('el-select', {
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }, _vm._l((_vm.cates), function(cate, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": cate,
          "value": cate
        }
      })
    })) : _vm._e(), _vm._v(" "), (item.type === 'switch') ? _c('el-switch', {
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }) : _vm._e()], 1)
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "aQyP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar',
  data: function data() {
    return {
      title: '',
      fullPath: ''
    };
  },

  watch: {
    '$route': function $route(route) {
      this.fullPath = route.path.split('/').slice(0, 3).join('/');
    }
  },
  methods: {
    push: function push(name) {
      this.$router.push({ name: name });
    },
    handleSelect: function handleSelect(indexPath) {
      this.$router.push({ path: indexPath });
    }
  },
  beforeMount: function beforeMount() {
    this.fullPath = this.$route.path.split('/').slice(0, 3).join('/');
  }
});

/***/ }),

/***/ "aR/N":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("XnCc")
}
var Component = __webpack_require__("AVtK")(
  /* script */
  __webpack_require__("5/fi"),
  /* template */
  __webpack_require__("ml9b"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f050399",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "bEjz":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "sidebar"
  }, [_c('el-col', {
    staticClass: "full-height",
    attrs: {
      "span": 4
    }
  }, [_c('el-menu', {
    staticClass: "full-height",
    attrs: {
      "default-active": "2",
      "unique-opened": true
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/dashboard"
    }
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v("概述")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v("文章管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/post/list"
    }
  }, [_vm._v("文章列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/post/create"
    }
  }, [_vm._v("添加文章")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-message"
  }), _vm._v("页面管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/page/list"
    }
  }, [_vm._v("页面列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/page/create"
    }
  }, [_vm._v("添加页面")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-menu"
  }), _vm._v("主题管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/theme/list"
    }
  }, [_vm._v("主题列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/theme/create"
    }
  }, [_vm._v("编辑主题")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "5"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-star-on"
  }), _vm._v("分类管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/cate/list"
    }
  }, [_vm._v("分类列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/cate/create"
    }
  }, [_vm._v("添加分类")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "6"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _vm._v("标签管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/tag/list"
    }
  }, [_vm._v("标签列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/tag/create"
    }
  }, [_vm._v("添加标签")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "7"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _vm._v("音乐管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/music/list"
    }
  }, [_vm._v("音乐列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/music/create"
    }
  }, [_vm._v("添加音乐")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/user/edit"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _vm._v("用户设置")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "9"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v("系统设置")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/option/general"
    }
  }, [_vm._v("基本设置")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/option/comment"
    }
  }, [_vm._v("评论设置")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/option/analytic"
    }
  }, [_vm._v("统计代码")])], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "d7n3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_api__ = __webpack_require__("vZNG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_error__ = __webpack_require__("uiUg");

//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {};
  },

  computed: {
    siteInfo: function siteInfo() {
      return this.$store.state.siteInfo;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.$store.dispatch('FETCH_OPTIONS').then(function () {
      if (_this.siteInfo['title'] && typeof document !== 'undefined') {
        document.title = _this.siteInfo['title'].value;
      }
    });
    var axios = __WEBPACK_IMPORTED_MODULE_1__store_api__["a" /* default */].axios;


    axios.interceptors.request.use(function (config) {
      var token = localStorage.getItem('token');
      if (config.method === 'get' && config.url.indexOf('/proxyPrefix/api/user') === -1) return config;
      if (token !== null && typeof token !== 'undefined') {
        config.headers['authorization'] = token;
      }
      return config;
    }, function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });

    axios.interceptors.response.use(function (response) {
      if (_this.$store.state.route.name === 'logout') {
        return response;
      }
      if (response.data && response.data.status && response.data.status === 'fail') {
        var desc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_error__["a" /* getChineseDesc */])(response.data.description);
        _this.$notify.error(desc);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(desc);
      }
      return response;
    }, function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),

/***/ "fEx8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gRTk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_marked__ = __webpack_require__("ATuT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("Ym9J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("o/kp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'markdown',
  props: ['value', 'toc'],
  data: function data() {
    return {
      labels: {
        'edit': '编辑模式',
        'split': '分屏模式',
        'preview': '预览模式',
        'full': '全屏模式',
        'toc': 'TOC模式'
      },
      mode: 'edit', // ['edit', 'split', 'preview', 'toc'],
      isUploadShow: false,
      supportWebp: false,
      upToken: '',
      bucketHost: '',
      key: '',
      form: {}

    };
  },

  computed: {
    compiledMarkdown: function compiledMarkdown() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_marked__["b" /* marked */])(this.value.replace(/<!-- more -->/g, ''));
    }
  },
  methods: {
    handlePreview: function handlePreview(file) {},
    handleSuccess: function handleSuccess(response, file, filelist) {
      var _this = this;

      var key = response.key;
      var prefix = this.supportWebp ? 'webp/' : '';
      var preUrl = this.bucketHost + '/' + encodeURI(key);
      var url = this.bucketHost + '/' + prefix + encodeURI(key);

      this.$store.dispatch('GET_IMAGE_HEIGHT', {
        url: preUrl
      }).then(function (height) {
        var target = '<img height="' + height + '" src="' + url + '">';
        _this.$confirm(target, '上传成功，是否插入图片链接？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false
        }).then(function () {
          _this.isUploadShow = false;
          _this._preInputText(target, 12, 12);
          _this.$message({
            type: 'success',
            message: '已插入图片链接'
          });
        }).catch(function () {
          _this.isUploadShow = false;
          _this.$message({
            type: 'info',
            message: '已取消图片链接'
          });
        });
      });
    },
    handleError: function handleError(err, response, file) {
      if (err.status === 401) {
        this.$message.error('图片上传失败，请求中未带Token');
      } else {
        this.$message.error(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(err));
      }
    },
    handleSelect: function handleSelect(key, keyPath) {
      if (keyPath.length === 1) {
        switch (key) {
          case '1':
            this._boldText();
            break;
          case '2':
            this._italicText();
            break;
          case '3':
            this._blockquoteText();
            break;
          case '4':
            this._codeText();
            break;
          case '6':
            this._insertMore();
            break;
          case '8':
            this.mode = 'toc';
            break;
        }
      } else if (keyPath.length === 2) {
        switch (key) {
          case '5-1':
            this._uploadImage();
            break;
          case '5-2':
            this._importImage();
            break;
          case '7-1':
            this.mode = 'edit';
            break;
          case '7-2':
            this.mode = 'split';
            break;
          case '7-3':
            this.mode = 'preview';
            break;
          case '7-4':
            this.mode = 'edit';
            break;
        }
      }
    },
    handleTab: function handleTab(e) {
      this._preInputText('\t');
      e.preventDefault();
    },

    handleInput: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function (e) {
      var value = e.target.value;
      this.input = value;
      this.$emit('input', value);
    }, 300),
    handleTocInput: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function (e) {
      var value = e.target.value;
      this.$emit('change', value);
    }, 300),
    _preInputText: function _preInputText(text, preStart, preEnd) {
      var textControl = this.$refs.markdown;
      var start = textControl.selectionStart;
      var end = textControl.selectionEnd;
      var origin = this.value;
      if (start !== end) {
        var exist = origin.slice(start, end);
        text = text.slice(0, preStart) + exist + text.slice(preEnd);
        preEnd = preStart + exist.length;
      }
      var input = origin.slice(0, start) + text + origin.slice(end);
      this.$emit('input', input);
    },
    _uploadImage: function _uploadImage() {
      this.isUploadShow = true;
    },
    beforeUpload: function beforeUpload(file) {
      var _this2 = this;

      var curr = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('HHmmss').toString();
      var prefix = __WEBPACK_IMPORTED_MODULE_3_moment___default()(file.lastModified).format('HHmmss').toString();
      var suffix = file.name;
      var key = encodeURI(curr + '/' + prefix + '_' + suffix);
      return this.$store.dispatch('GET_IMAGE_TOKEN', {
        key: key
      }).then(function (response) {
        _this2.upToken = response.upToken;
        _this2.key = response.key;
        _this2.bucketHost = response.bucketHost;
        _this2.supportWebp = response.supportWebp;
        if (_this2.bucketHost === '') {
          _this2.$notify.error('获取七牛token失败，请确认配置文件');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject();
        }
        _this2.form = {
          key: key,
          token: _this2.upToken
        };
      });
    },
    _importImage: function _importImage() {
      var _this3 = this;

      this.$prompt('请输入图片链接', '导入图片链接', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function (_ref) {
        var value = _ref.value;

        _this3._preInputText('![](' + value + ')', 12, 12);
        _this3.$message({
          type: 'success',
          message: '已插入图片链接'
        });
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消插入图片链接'
        });
      });
    },
    _insertMore: function _insertMore() {
      this._preInputText('<!-- more -->', 12, 12);
    },
    _boldText: function _boldText() {
      this._preInputText('**加粗文字**', 2, 6);
    },
    _italicText: function _italicText() {
      this._preInputText('_斜体文字_', 1, 5);
    },
    _blockquoteText: function _blockquoteText() {
      this._preInputText('\n> 引用', 3, 5);
    },
    _codeText: function _codeText() {
      this._preInputText('\n```\ncode block\n```', 5, 15);
    }
  }
});

/***/ }),

/***/ "h5qd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jtY0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ml9b":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_vm._l((_vm.options.items), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": item.label
      }
    }, [(typeof item.description === 'undefined') ? _c('el-input', {
      attrs: {
        "autosize": {
          minRows: 2,
          maxRows: 16
        },
        "type": item.type || 'text'
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }) : _vm._e(), _vm._v(" "), (typeof item.description !== 'undefined') ? _c('el-popover', {
      attrs: {
        "placement": "right-start",
        "title": item.label,
        "width": "50%",
        "trigger": "hover",
        "content": item.description
      }
    }, [_c('el-input', {
      attrs: {
        "slot": "reference",
        "autosize": {
          minRows: 2,
          maxRows: 16
        },
        "type": item.type || 'text'
      },
      slot: "reference",
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    })], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "o70f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_api__ = __webpack_require__("vZNG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      title: '',
      form: {
        name: '',
        password: ''
      }
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__store_api__["a" /* default */].login(this.form).then(function (response) {
        if (response.data.status === 'fail') {
          _this.$message({
            message: '登录失败，请检查账号和密码',
            duration: 2000,
            type: 'error'
          });
        } else if (response.data.status === 'success') {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('username', _this.form.name);
          _this.$message({
            title: '成功',
            message: '登录成功',
            type: 'success',
            duration: 2000
          });
          _this.$store.dispatch('FETCH_USER', {
            model: 'user',
            query: {},
            username: _this.form.name
          }).then(function () {
            _this.$router.push({ path: '/dashboard' });
          });
        }
      }).catch(function (err) {
        return console.error(err);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$store.dispatch('FETCH_OPTIONS').then(function (result) {
      _this2.title = _this2.$store.state.siteInfo['title'].value || '';
    });
  }
});

/***/ }),

/***/ "oIJa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oaya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      sliderValue: 100,
      data: [],
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      list: []
    };
  },

  methods: {
    handleNodeClick: function handleNodeClick(data, node, tree) {
      if (data.title !== '最近发布的文章') {
        this.$router.push({
          name: data.type === 'post' ? 'postCreate' : 'pageCreate',
          params: { id: data._id }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('FETCH', {
      model: 'post',
      query: {
        select: {
          title: 1,
          type: 1
        },
        sort: {
          createdAt: -1
        },
        limit: 10
      }
    }).then(function (list) {
      _this.data = [{
        title: '最近发布的文章',
        children: list
      }];
    });
  }
});

/***/ }),

/***/ "pyvE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("aA9S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("ZLEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'list',
  props: ['options'],
  data: function data() {
    var isPost = this.options.name === 'post';
    var isPage = this.options.name === 'page';
    return {
      isPost: isPost,
      isPage: isPage,
      isLoading: true
    };
  },

  computed: {
    list: function list() {
      return this.$store.state.list;
    },
    filters: function filters() {
      if (!this.isPost && !this.isPage) return [];
      var obj = this.list.reduce(function (prev, value) {
        Array.isArray(value.tags) && value.tags.forEach(function (tag) {
          prev[tag] = { text: tag, value: tag };
        });
        return prev;
      }, {});
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).map(function (value) {
        return obj[value];
      });
    }
  },
  methods: {
    filterTag: function filterTag(value, row) {
      return row.tags.indexOf(value) !== -1;
    },
    handleClick: function handleClick(_ref) {
      var _id = _ref._id;

      this.$router.push({
        path: '/' + this.options.name + '/create/' + _id
      });
    },
    handleDelete: function handleDelete(_ref2, index) {
      var _this = this;

      var _id = _ref2._id;

      this.$store.dispatch('DELETE', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        id: _id
      }, this.options)).then(function () {
        _this.$store.state.list.splice(index, 1);
      }).catch(function (err) {
        return console.log(err);
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.$store.dispatch('FETCH_LIST', this.options).then(function () {
      _this2.isLoading = false;
    }).catch(function (err) {
      return console.error(err);
    });
  }
});

/***/ }),

/***/ "s6+2":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("Ja2Y")
}
var Component = __webpack_require__("AVtK")(
  /* script */
  __webpack_require__("23S4"),
  /* template */
  __webpack_require__("XG0p"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-12be0f29",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "snFu":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("h5qd")
}
var Component = __webpack_require__("AVtK")(
  /* script */
  __webpack_require__("pyvE"),
  /* template */
  __webpack_require__("vkbn"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f79a10a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "szkk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("KH7x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("a3Yh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("aA9S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Markdown__ = __webpack_require__("QPbI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_marked__ = __webpack_require__("ATuT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("Ym9J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'post',
  props: ['options'],
  components: {
    Markdown: __WEBPACK_IMPORTED_MODULE_4__Markdown___default.a
  },
  data: function data() {
    var isPost = this.options.name === 'post';
    var isPage = this.options.name === 'page';
    var id = typeof this.$route.params.id === 'undefined' ? -1 : this.$route.params.id;
    var form = this.options.items.reduce(function (prev, curr) {
      prev[curr.prop] = Array.isArray(curr.default) ? curr.default.map(function (value) {
        return value;
      }) : curr.default;
      return prev;
    }, {});
    form.type = this.options.name;
    return {
      isPost: isPost,
      isPage: isPage,
      cates: [],
      tags: [],
      form: form,
      id: id,
      test: '',
      isLoading: id !== -1,
      markdownChecked: false
    };
  },

  computed: {
    splitIndex: function splitIndex() {
      return this.options.items.reduce(function (prev, curr, index) {
        if (curr.type === 'split') {
          return index;
        }
        return prev;
      }, -1);
    },
    prevItems: function prevItems() {
      return this.options.items.slice(0, this.splitIndex);
    },
    nextItems: function nextItems() {
      return this.options.items.slice(this.splitIndex);
    }
  },
  watch: {
    'form.markdownContent': {
      immediate: true,
      handler: function handler(val, oldVal) {
        if (!val || !this.form.updatedAt) return;
        var url = this.$store.state.siteInfo.siteUrl.value;
        var path = this.form.pathName;
        var key = url + '|' + path;
        var temp = this.getLS(key) || '';

        var realVal = temp.replace(/\|\d+$/gm, '');
        var matched = temp.match(/\d+$/gm);
        var historyTimestamp = parseInt(matched ? matched.slice(-1) : Date.now());
        var currentTimestamp = new Date(this.form.updatedAt).valueOf();
        if (temp !== '' && val !== realVal && this.markdownChecked === false && historyTimestamp >= currentTimestamp) {
          this.restore(key, realVal);
        } else if (this.markdownChecked === true) {
          var targetVal = val + ('|' + Date.now());
          this.saveLS(key, targetVal);
        }
        this.markdownChecked = true;
      }
    }
  },
  methods: {
    jump: function jump(type) {
      var _this = this;

      if (this.id === -1) return;
      var key = type === 'prev' ? '$lt' : '$gt';
      var query = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.options.query);
      query.conditions['_id'] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, key, this.form._id);
      query.limit = 1;
      if (type === 'prev') {
        query.sort = { '_id': -1 };
      }
      this.$store.dispatch('FETCH', {
        model: this.options.model,
        query: query
      }).then(function (item) {
        if (item.length !== 0) {
          var id = item[0]._id;
          _this.$router.push({ params: { id: id } });
          _this.id = id;
        }
      });
    },
    restore: function restore(key, val) {
      var _this2 = this;

      this.$confirm('', '发现草稿，是否恢复？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false
      }).then(function () {
        _this2.form.markdownContent = val;
        _this2.$message({
          type: 'success',
          message: '已恢复草稿'
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消恢复，提交文章后将清理草稿'
        });
      });
    },
    saveLS: function saveLS(key, value) {
      window.localStorage.setItem(key, value);
    },
    getLS: function getLS(key) {
      return window.localStorage.getItem(key);
    },
    onSaveToc: function onSaveToc() {
      __WEBPACK_IMPORTED_MODULE_5__utils_marked__["a" /* toc */].length = 0;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_marked__["b" /* marked */])(this.form.markdownContent);
      var tocMarkdown = this.tocToTree(__WEBPACK_IMPORTED_MODULE_5__utils_marked__["a" /* toc */]);
      this.form.markdownToc = '**文章目录**\n' + tocMarkdown;
    },
    tocToTree: function tocToTree(toc) {
      return toc.map(function (item) {
        var times = (item.level - 1) * 2;
        return ' '.repeat(times) + ' - [' + item.title + '](#' + item.slug + ')';
      }).join('\n');
    },
    validate: function validate() {
      this.form.summary = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_marked__["b" /* marked */])(this.form.markdownContent.split('<!-- more -->')[0]);
      this.form.content = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_marked__["b" /* marked */])(this.form.markdownContent.replace(/<!-- more -->/g, ''));
      this.form.markdownToc = this.form.markdownToc || '';
      this.form.toc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_marked__["b" /* marked */])(this.form.markdownToc);
      if (this.form.createdAt === '') {
        this.form.createdAt = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss');
      } else {
        this.form.createdAt = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.createdAt).format('YYYY-MM-DD HH:mm:ss');
      }
      this.form.updatedAt = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss');
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.validate();
      this.$store.dispatch('POST', {
        model: this.options.model,
        form: this.form
      }).then(function (response) {
        var url = _this3.$store.state.siteInfo.siteUrl.value;
        var path = _this3.form.pathName;
        var timestamp = new Date(_this3.form.updatedAt).valueOf();
        var key = url + '|' + path;
        _this3.saveLS(key, _this3.form.markdownContent + ('|' + timestamp));
        _this3.$message({
          message: '文章已成功提交',
          type: 'success'
        });
        if (response._id && _this3.id === -1) {
          _this3.$router.replace({ params: { id: response._id } });
          _this3.form = response;
          _this3.id = response.id;
        }
      }).catch(function (err) {
        return console.error(err);
      });
    },
    handleAddTag: function handleAddTag(tag) {
      this.form.tags.indexOf(tag) === -1 && this.form.tags.push(tag);
    },
    handleDelete: function handleDelete(index) {
      this.form.tags.splice(index, 1);
    }
  },
  created: function created() {
    var _this4 = this;

    if (this.id !== -1) {
      // fetch from post model
      this.$store.dispatch('FETCH_BY_ID', {
        model: this.options.model,
        id: this.id,
        query: {}
      }).then(function (post) {
        _this4.isLoading = false;
        post.type = _this4.options.name;
        _this4.form = post;
      });
    }
    if (this.isPage) return;
    var fetchCate = this.$store.dispatch('FETCH', {
      model: 'category',
      query: {}
    });
    var fetchTag = this.$store.dispatch('FETCH', {
      model: 'tag',
      query: {}
    });
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([fetchCate, fetchTag]).then(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          cates = _ref2[0],
          tags = _ref2[1];

      _this4.cates = cates.map(function (value) {
        return value.name;
      });
      _this4.tags = tags.map(function (value) {
        return value.name;
      });
    }).catch(function (err) {
      return console.log(err);
    });
  }
});

/***/ }),

/***/ "uiUg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChineseDesc; });
/**
 * Created by unsad on 2017/10/15.
 */
var getChineseDesc = function getChineseDesc(desc) {
  switch (desc) {
    case 'Token not found':
      return '请求失败，请确认您已登录';
    case 'Get token failed.Check the password':
      return '登录失败，请检查您的密码';
    case 'Get token failed.Check the name':
      return '登录失败，请检查您的账号';
    case 'Token verify failed':
    case 'Token invalid':
      return 'Token验证失败，请重新登录';
    default:
      return desc;
  }
};

/***/ }),

/***/ "vZNG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("ZLEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("BMa3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

/**
 * Created by unsad on 2017/5/23.
 */


var root = '/proxyPrefix/api';

var store = {};

/* harmony default export */ __webpack_exports__["a"] = (store);

function isObject(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'Object';
}

function convertObjectToArray(args) {
  return isObject(args) ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(args).map(function (value, index) {
    var temp = {};
    temp[value] = args[value];
    return temp;
  }) : [];
}
store.axios = __WEBPACK_IMPORTED_MODULE_1_axios___default.a;

store.login = function (conditions, args) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/proxyPrefix/admin/login', conditions);
};

store.logout = function (conditions, args) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/proxyPrefix/admin/logout', conditions);
};

store.getImageHeight = function (url) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url + '?imageInfo').then(function (response) {
    return response.data;
  });
};

store.getImageToken = function (body) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/proxyPrefix/admin/qiniu', body).then(function (response) {
    return response.data;
  });
};

store.fetchList = function (model, query) {
  var target = root + '/' + model;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(target, { params: query }).then(function (response) {
    return response.data;
  });
};

store.fetchByID = function (model, id, query) {
  var target = root + '/' + model + '/' + id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(target, { params: query }).then(function (response) {
    return response.data;
  });
};

store.patchByID = function (model, id, form) {
  var target = root + '/' + model + '/' + id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(target, form).then(function (response) {
    return response.data;
  });
};

store.post = function (model, form) {
  var target = root + '/' + model;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(target, form).then(function (response) {
    return response.data;
  });
};

store.deleteByID = function (model, id) {
  var target = root + '/' + model + '/' + id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(target).then(function (response) {
    return response.data;
  });
};

/***/ }),

/***/ "vkbn":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.isLoading),
      expression: "isLoading",
      modifiers: {
        "body": true
      }
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "border": ""
    }
  }, [_vm._l((_vm.options.items), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "prop": item.prop,
        "label": item.label,
        "width": item.width
      }
    })
  }), _vm._v(" "), (_vm.isPost) ? _c('el-table-column', {
    attrs: {
      "prop": "category",
      "label": "分类",
      "width": "120"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.category) ? _c('el-tag', {
            attrs: {
              "type": 'primary',
              "close-transition": ""
            }
          }, [_vm._v("\n      " + _vm._s(_vm.row.category) + "\n    ")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPost) ? _c('el-table-column', {
    attrs: {
      "prop": "tags",
      "label": "标签",
      "width": "180",
      "filters": _vm.filters,
      "filter-method": _vm.filterTag
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _vm._l((_vm.row.tags), function(tag, index) {
            return _c('el-tag', {
              key: index,
              attrs: {
                "type": 0 ? 'primary' : 'success',
                "close-transition": ""
              }
            }, [_vm._v(_vm._s(tag))])
          })
        
      },
      staticRenderFns: []
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.options.isButtonFixed) ? _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "操作",
      "width": "150"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "info",
              "size": "small"
            },
            on: {
              "click": function($event) {
                _vm.handleClick(_vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "danger",
              "size": "small"
            },
            on: {
              "click": function($event) {
                _vm.handleDelete(_vm.row, _vm.$index)
              }
            }
          }, [_vm._v("删除")])], 1)
        
      },
      staticRenderFns: []
    }
  }) : _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "context": _vm._self,
      "label": "操作",
      "width": "150"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "info",
              "size": "small"
            },
            on: {
              "click": function($event) {
                _vm.handleClick(_vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "danger",
              "size": "small"
            },
            on: {
              "click": function($event) {
                _vm.handleDelete(_vm.row, _vm.$index)
              }
            }
          }, [_vm._v("删除")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ "wXMN":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("3rbi")
}
var Component = __webpack_require__("AVtK")(
  /* script */
  __webpack_require__("aQyP"),
  /* template */
  __webpack_require__("bEjz"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-10f3745e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "wYys":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yxhs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'top',
  data: function data() {
    return {
      title: ''
    };
  },

  computed: {
    displayName: function displayName() {
      return this.$store.state.user.displayName || -1;
    }
  },
  methods: {
    handleSelect: function handleSelect(index, indexPath) {
      if (index === '1-1') {
        this.$router.push({
          name: 'userEdit'
        });
      } else if (index === '1-2') {
        this.$router.push({
          name: 'logout'
        });
      }
    }
  },
  created: function created() {
    if (this.displayName === -1) {
      var username = localStorage.getItem('username');
      this.$store.dispatch('FETCH_USER', {
        model: 'user',
        query: {},
        username: username
      }).catch(function (err) {
        return console.error(err);
      });
    }
  }
});

/***/ }),

/***/ "zvdn":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-panel"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": "1",
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("加粗")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("斜体")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("引用")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_vm._v("代码段")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "5"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("插入图片")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5-1"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload2"
  }), _vm._v("上传图片")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5-2"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v("网络图片")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "6"
    }
  }, [_c('i', {
    staticClass: "el-icon-more"
  }), _vm._v("摘要")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "7"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.labels[_vm.mode]))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7-1"
    }
  }, [_vm._v(_vm._s(_vm.labels['edit']))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7-2"
    }
  }, [_vm._v(_vm._s(_vm.labels['split']))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7-3"
    }
  }, [_vm._v(_vm._s(_vm.labels['preview']))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7-4"
    }
  }, [_vm._v(_vm._s(_vm.labels['full']))])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "8"
    }
  }, [_c('i', {
    staticClass: "el-icon-deit"
  }), _vm._v("编辑TOC")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "图片上传",
      "modal": false
    },
    model: {
      value: (_vm.isUploadShow),
      callback: function($$v) {
        _vm.isUploadShow = $$v
      },
      expression: "isUploadShow"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "//up.qbox.me/",
      "drag": "",
      "on-success": _vm.handleSuccess,
      "on-error": _vm.handleError,
      "show-file-list": true,
      "data": _vm.form,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("请确保后台已将七牛(server/conf/config.js)相关配置确认")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-editor",
    class: {
      'edit': _vm.mode === 'edit',
        'preview': _vm.mode === 'preview',
        'split': _vm.mode === 'split',
        'toc': _vm.mode === 'toc'
    }
  }, [_c('textarea', {
    ref: "markdown",
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.handleInput,
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key)) { return null; }
        _vm.handleTab($event)
      }
    }
  }), _vm._v(" "), (_vm.mode !== 'toc') ? _c('div', {
    staticClass: "md-preview markdown",
    domProps: {
      "innerHTML": _vm._s(_vm.compiledMarkdown)
    }
  }) : _c('textarea', {
    ref: "toc",
    staticClass: "md-preview markdown",
    domProps: {
      "value": _vm.toc
    },
    on: {
      "input": _vm.handleTocInput
    }
  })])], 1)
},staticRenderFns: []}

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.433fe12e3cfaeaab6c2f.js